"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdkVersion = void 0;
const version_1 = require("./version");
const getSdkVersion = () => version_1.version;
exports.getSdkVersion = getSdkVersion;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXNkay12ZXJzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dldC1zZGstdmVyc2lvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx1Q0FBbUM7QUFFNUIsTUFBTSxhQUFhLEdBQUcsR0FBRyxFQUFFLENBQUMsaUJBQU8sQ0FBQTtBQUE3QixRQUFBLGFBQWEsaUJBQWdCIn0=